import { observer } from 'mobx-react-lite'
import { type DocumentManagementViewModel } from '@/features/documents/DocumentManagementViewModel'
import { DocumentManagementTableHeaderRow } from '@/features/documents/components/DocumentManagementTable/DocumentManagementTableHeaderRow'

export interface DocumentManagementTableHeaderRowContainerProps {
  vm: DocumentManagementViewModel
}

export const DocumentManagementTableHeaderRowContainer = observer(
  function DocumentManagementTableHeaderRowContainer({
    vm,
  }: DocumentManagementTableHeaderRowContainerProps) {
    return (
      <DocumentManagementTableHeaderRow
        columns={vm.columnHeaders}
        onSort={vm.setSortOrder}
      />
    )
  },
)
